// GET_DASHBOARD
export const GET_DASHBOARD_REQUEST = "GET_DASHBOARD_REQUEST";
export const GET_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS";
export const GET_DASHBOARD_FAILED = "GET_DASHBOARD_FAILED";

// GET_USERS
export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILED = "GET_USERS_FAILED";

// GET_ADMINS
export const GET_ADMINS_REQUEST = "GET_ADMINS_REQUEST";
export const GET_ADMINS_SUCCESS = "GET_ADMINS_SUCCESS";
export const GET_ADMINS_FAILED = "GET_ADMINS_FAILED";

// GET_COURSES
export const GET_COURSES_REQUEST = "GET_COURSES_REQUEST";
export const GET_COURSES_SUCCESS = "GET_COURSES_SUCCESS";
export const GET_COURSES_FAILED = "GET_COURSES_FAILED";

// GET_COURSE_USERS
export const GET_COURSE_USERS_REQUEST = "GET_COURSE_USERS_REQUEST";
export const GET_COURSE_USERS_SUCCESS = "GET_COURSE_USERS_SUCCESS";
export const GET_COURSE_USERS_FAILED = "GET_COURSE_USERS_FAILED";

// GET_COURSE_MESSAGES
export const GET_COURSE_MESSAGES_REQUEST = "GET_COURSE_MESSAGES_REQUEST";
export const GET_COURSE_MESSAGES_SUCCESS = "GET_COURSE_MESSAGES_SUCCESS";
export const GET_COURSE_MESSAGES_FAILED = "GET_COURSE_MESSAGES_FAILED";


// GET_NEW_COURSES
export const GET_NEW_COURSES_REQUEST = "GET_NEW_COURSES_REQUEST";
export const GET_NEW_COURSES_SUCCESS = "GET_NEW_COURSES_SUCCESS";
export const GET_NEW_COURSES_FAILED = "GET_NEW_COURSES_FAILED";

// GET_WAITING_COURSES
export const GET_WAITING_COURSES_REQUEST = "GET_WAITING_COURSES_REQUEST";
export const GET_WAITING_COURSES_SUCCESS = "GET_WAITING_COURSES_SUCCESS";
export const GET_WAITING_COURSES_FAILED = "GET_WAITING_COURSES_FAILED";

// POST_COURSE
export const POST_COURSE_REQUEST = "POST_COURSE_REQUEST";
export const POST_COURSE_SUCCESS = "POST_COURSE_SUCCESS";
export const POST_COURSE_FAILED = "POST_COURSE_FAILED";


// PATCH_COURSE
export const PATCH_COURSE_REQUEST = "PATCH_COURSE_REQUEST";
export const PATCH_COURSE_SUCCESS = "PATCH_COURSE_SUCCESS";
export const PATCH_COURSE_FAILED = "PATCH_COURSE_FAILED";

// DELETE_COURSE
export const DELETE_COURSE_REQUEST = "DELETE_COURSE_REQUEST";
export const DELETE_COURSE_SUCCESS = "DELETE_COURSE_SUCCESS";
export const DELETE_COURSE_FAILED = "DELETE_COURSE_FAILED";

// POST_COURSE_ENROLL
export const POST_COURSE_ENROLL_REQUEST = "POST_COURSE_ENROLL_REQUEST";
export const POST_COURSE_ENROLL_SUCCESS = "POST_COURSE_ENROLL_SUCCESS";
export const POST_COURSE_ENROLL_FAILED = "POST_COURSE_ENROLL_FAILED";

// POST_QUIZ
export const POST_QUIZ_REQUEST = "POST_QUIZ_REQUEST";
export const POST_QUIZ_SUCCESS = "POST_QUIZ_SUCCESS";
export const POST_QUIZ_FAILED = "POST_QUIZ_FAILED";

// GET_QUIZ_DETAILS
export const GET_QUIZ_DETAILS_REQUEST = "GET_QUIZ_DETAILS_REQUEST";
export const GET_QUIZ_DETAILS_SUCCESS = "GET_QUIZ_DETAILS_SUCCESS";
export const GET_QUIZ_DETAILS_FAILED = "GET_QUIZ_DETAILS_FAILED";



// POST_APPROVE_REQ
export const POST_APPROVE_REQ_REQUEST = "POST_APPROVE_REQ_REQUEST";
export const POST_APPROVE_REQ_SUCCESS = "POST_APPROVE_REQ_SUCCESS";
export const POST_APPROVE_REQ_FAILED = "POST_APPROVE_REQ_FAILED";

// GET_COURSE_ENROLL_REQ
export const GET_COURSE_ENROLL_REQ_REQUEST = "GET_COURSE_ENROLL_REQ_REQUEST";
export const GET_COURSE_ENROLL_REQ_SUCCESS = "GET_COURSE_ENROLL_REQ_SUCCESS";
export const GET_COURSE_ENROLL_REQ_FAILED = "GET_COURSE_ENROLL_REQ_FAILED";

// GET_CONTENT
export const GET_CONTENT_REQUEST = "GET_CONTENT_REQUEST";
export const GET_CONTENT_SUCCESS = "GET_CONTENT_SUCCESS";
export const GET_CONTENT_FAILED = "GET_CONTENT_FAILED";



// POST_CONTENT
export const POST_CONTENT_REQUEST = "POST_CONTENT_REQUEST";
export const POST_CONTENT_SUCCESS = "POST_CONTENT_SUCCESS";
export const POST_CONTENT_FAILED = "POST_CONTENT_FAILED";

// PATCH_CONTENT_REORDER
export const PATCH_CONTENT_REORDER_REQUEST = "PATCH_CONTENT_REORDER_REQUEST";
export const PATCH_CONTENT_REORDER_SUCCESS = "PATCH_CONTENT_REORDER_SUCCESS";
export const PATCH_CONTENT_REORDER_FAILED = "PATCH_CONTENT_REORDER_FAILED";

// POST_SUBMIT_QUIZ
export const POST_SUBMIT_QUIZ_REQUEST = "POST_SUBMIT_QUIZ_REQUEST";
export const POST_SUBMIT_QUIZ_SUCCESS = "POST_SUBMIT_QUIZ_SUCCESS";
export const POST_SUBMIT_QUIZ_FAILED = "POST_SUBMIT_QUIZ_FAILED";

// DELETE_CONTENT
export const DELETE_CONTENT_REQUEST = "DELETE_CONTENT_REQUEST";
export const DELETE_CONTENT_SUCCESS = "DELETE_CONTENT_SUCCESS";
export const DELETE_CONTENT_FAILED = "DELETE_CONTENT_FAILED";

// DELETE_FOLDER
export const DELETE_FOLDER_REQUEST = "DELETE_FOLDER_REQUEST";
export const DELETE_FOLDER_SUCCESS = "DELETE_FOLDER_SUCCESS";
export const DELETE_FOLDER_FAILED = "DELETE_FOLDER_FAILED";


// GET_NEWS
export const GET_NEWS_REQUEST = "GET_NEWS_REQUEST";
export const GET_NEWS_SUCCESS = "GET_NEWS_SUCCESS";
export const GET_NEWS_FAILED = "GET_NEWS_FAILED";

// GET_DOWNLOADED_NEWS
export const GET_DOWNLOADED_NEWS_REQUEST = "GET_DOWNLOADED_NEWS_REQUEST";
export const GET_DOWNLOADED_NEWS_SUCCESS = "GET_DOWNLOADED_NEWS_SUCCESS";
export const GET_DOWNLOADED_NEWS_FAILED = "GET_DOWNLOADED_NEWS_FAILED";

// POST_NEWS
export const POST_NEWS_REQUEST = "POST_NEWS_REQUEST";
export const POST_NEWS_SUCCESS = "POST_NEWS_SUCCESS";
export const POST_NEWS_FAILED = "POST_NEWS_FAILED";

// GET_ALL_CHATS
export const GET_ALL_CHATS_REQUEST = "GET_ALL_CHATS_REQUEST";
export const GET_ALL_CHATS_SUCCESS = "GET_ALL_CHATS_SUCCESS";
export const GET_ALL_CHATS_FAILED = "GET_ALL_CHATS_FAILED";

// GET_CHAT
export const GET_CHAT_REQUEST = "GET_CHAT_REQUEST";
export const GET_CHAT_SUCCESS = "GET_CHAT_SUCCESS";
export const GET_CHAT_FAILED = "GET_CHAT_FAILED";

// GET_ALL_QUIZ
export const GET_ALL_QUIZ_REQUEST = "GET_ALL_QUIZ_REQUEST";
export const GET_ALL_QUIZ_SUCCESS = "GET_ALL_QUIZ_SUCCESS";
export const GET_ALL_QUIZ_FAILED = "GET_ALL_QUIZ_FAILED";

// GET_QUIZ
export const GET_QUIZ_REQUEST = "GET_QUIZ_REQUEST";
export const GET_QUIZ_SUCCESS = "GET_QUIZ_SUCCESS";
export const GET_QUIZ_FAILED = "GET_QUIZ_FAILED";

// GET_ALL_FOLDERS
export const GET_ALL_FOLDERS_REQUEST = "GET_ALL_FOLDERS_REQUEST";
export const GET_ALL_FOLDERS_SUCCESS = "GET_ALL_FOLDERS_SUCCESS";
export const GET_ALL_FOLDERS_FAILED = "GET_ALL_FOLDERS_FAILED";

// POST_FOLDER
export const POST_FOLDER_REQUEST = "POST_FOLDER_REQUEST";
export const POST_FOLDER_SUCCESS = "POST_FOLDER_SUCCESS";
export const POST_FOLDER_FAILED = "POST_FOLDER_FAILED";

// GET_FOLDER_MATERIAL
export const GET_FOLDER_MATERIAL_REQUEST = "GET_FOLDER_MATERIAL_REQUEST";
export const GET_FOLDER_MATERIAL_SUCCESS = "GET_FOLDER_MATERIAL_SUCCESS";
export const GET_FOLDER_MATERIAL_FAILED = "GET_FOLDER_MATERIAL_FAILED";

// TOGGLE_FOLDERS
export const TOGGLE_FOLDERS = "TOGGLE_FOLDERS";

// TOGGLE_FOLDERS_COURSES
export const TOGGLE_FOLDERS_COURSES = "TOGGLE_FOLDERS_COURSES";

// OPEN_MAIL
export const OPEN_MAIL = "OPEN_MAIL";

// TOGGLE_USER_CHAT
export const TOGGLE_USER_CHAT = "TOGGLE_USER_CHAT";

// GET_SLUG
export const GET_SLUG_REQUEST = "GET_SLUG_REQUEST";
export const GET_SLUG_SUCCESS = "GET_SLUG_SUCCESS";
export const GET_SLUG_FAILED = "GET_SLUG_FAILED";

// GET_ALL_CONTENTS
export const GET_ALL_CONTENTS_REQUEST = "GET_ALL_CONTENTS_REQUEST";
export const GET_ALL_CONTENTS_SUCCESS = "GET_ALL_CONTENTS_SUCCESS";
export const GET_ALL_CONTENTS_FAILED = "GET_ALL_CONTENTS_FAILED";


// GET_MAIL
export const GET_MAIL_REQUEST = "GET_MAIL_REQUEST";
export const GET_MAIL_SUCCESS = "GET_MAIL_SUCCESS";
export const GET_MAIL_FAILED = "GET_MAIL_FAILED";

// SEND_MAIL
export const SEND_MAIL_REQUEST = "SEND_MAIL_REQUEST";
export const SEND_MAIL_SUCCESS = "SEND_MAIL_SUCCESS";
export const SEND_MAIL_FAILED = "SEND_MAIL_FAILED";

// READ_MAIL
export const READ_MAIL_REQUEST = "READ_MAIL_REQUEST";
export const READ_MAIL_SUCCESS = "READ_MAIL_SUCCESS";
export const READ_MAIL_FAILED = "READ_MAIL_FAILED";

// DELETE_MAIL
export const DELETE_MAIL_REQUEST = "DELETE_MAIL_REQUEST";
export const DELETE_MAIL_SUCCESS = "DELETE_MAIL_SUCCESS";
export const DELETE_MAIL_FAILED = "DELETE_MAIL_FAILED";


// STRIPE_ONBOARD
export const STRIPE_ONBOARD_REQUEST = "STRIPE_ONBOARD_REQUEST";
export const STRIPE_ONBOARD_SUCCESS = "STRIPE_ONBOARD_SUCCESS";
export const STRIPE_ONBOARD_FAILED = "STRIPE_ONBOARD_FAILED";

// GET_S3_URL
export const GET_S3_URL_REQUEST = "GET_S3_URL_REQUEST";
export const GET_S3_URL_SUCCESS = "GET_S3_URL_SUCCESS";
export const GET_S3_URL_FAILED = "GET_S3_URL_FAILED";



// CLEAR_HOME
export const CLEAR_HOME = "CLEAR_HOME";
